import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useParams, useQueryParams } from '@atlassian/mpac-ui';
import invariant from 'invariant';
import queryString from 'query-string';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { getNewReportPathname } from "../../ReportsFilters/ReportFilters.utils";

const FeedbackReportsTableContent = props => {
  const {
    partnerId,
    reportName
  } = useParams();
  const queryParams = useQueryParams();
  invariant(partnerId, 'Partner id is required');
  invariant(reportName, 'Report Name is required');

  if (props.feedbackCount === 0) {
    return '--';
  }

  let routeLink = '';
  const pathName = getNewReportPathname(partnerId, 'feedback-details', false);

  const newParams = _objectSpread(_objectSpread({}, queryParams), props.reasonKey ? {
    [props.reportBy]: props.reasonKey
  } : {});

  routeLink = "".concat(pathName, "?").concat(queryString.stringify(newParams));
  return /*#__PURE__*/React.createElement(RouteLink, {
    to: routeLink
  }, props.feedbackCount);
};

export default FeedbackReportsTableContent;